import React from 'react';
export const ArrowLeftIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "35.25",
  height: "35.25",
  x: "-.375",
  y: ".375",
  stroke: "#D4D4D4",
  strokeWidth: ".75",
  rx: "17.625",
  transform: "matrix(-1 0 0 1 35.25 0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "m18.53 21.97-1.06 1.06L12.44 18l5.03-5.03 1.06 1.06-3.22 3.22h7.19v1.5h-7.19l3.22 3.22Z"
}));
export const ArrowRightIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "35.25",
  height: "35.25",
  x: ".375",
  y: ".375",
  stroke: "#D4D4D4",
  strokeWidth: ".75",
  rx: "17.625"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "m17.47 21.97 1.06 1.06L23.56 18l-5.03-5.03-1.06 1.06 3.22 3.22H13.5v1.5h7.19l-3.22 3.22Z"
}));